import { Flex, Text } from "@mantine/core";
import { NavLink } from "react-router-dom";

import { MENU_ITEMS } from "../../constants";

export default function MobileNav() {
  return (
    <Flex bg="primary.1" justify="space-between" align="center" bdrs="lg" p="xs">
      {MENU_ITEMS.map((item) => (
        <NavLink
          viewTransition
          key={item.path}
          to={item.path}
          style={({ isActive }) => ({
            flexGrow: 1,
            padding: "7px 5px",
            borderRadius: "10px",
            backgroundColor: isActive ? "var(--mantine-color-neutral-1)" : "transparent",
          })}
        >
          {({ isActive }) => (
            <Flex gap="xs" justify="center" align="center">
              <item.icon color="var(--mantine-color-secondary-9)" size={16} />
              {isActive && (
                <Text fw="bold" fz="xs" c="secondary.9">
                  {item.label}
                </Text>
              )}
            </Flex>
          )}
        </NavLink>
      ))}
    </Flex>
  );
}
